import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigServerService } from '../../../core/services/config/server/config-server.service';
import { IUsuarioLogSituacaoResponse } from '../interfaces/usuario-log-situacao.interface';
import { IUsuarioLogAcessoResponse } from '../interfaces/usuario-log-acesso.interface';

@Injectable({
  providedIn: 'root',
})
export class UsuarioLogApi {
  private apiUrl = `${this.configServerService.getPathApi()}/usuario`;

  constructor(
    private http: HttpClient,
    private configServerService: ConfigServerService
  ) {}

  /** Pesquisa os registros de logs de situações do usuário informado */
  fetchSituacoes(idUsuario: number,page: number, pageSize: number): Observable<IUsuarioLogSituacaoResponse> {
    let params = new HttpParams();
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());

    return this.http.get<IUsuarioLogSituacaoResponse>(`${this.apiUrl}/${idUsuario}/logs/situacoes`, { params });
  }

  /** Pesquisa os registros de logs de acessos do usuário informado */
  fetchAcessos(idUsuario: number,page: number, pageSize: number): Observable<IUsuarioLogAcessoResponse> {
    let params = new HttpParams();
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());

    return this.http.get<IUsuarioLogAcessoResponse>(`${this.apiUrl}/${idUsuario}/logs/acessos`, { params });
  }
}
